import React, { memo, Suspense } from 'react';

import isEqual from 'lodash/isEqual';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { GenericErrorPage, HubErrorBoundary } from '@atlassian/company-hub-common';

import type { HubEditorConfigPanelProps } from './hub-editor-config-panel/types';

const HubEditorConfigPanelLazy = React.lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_hub-editor-config-panel" */
		'./hub-editor-config-panel'
	).then((mod) => ({ default: mod.HubEditorConfigPanel })),
);

export const HubEditorConfigPanelEntryPoint: React.MemoExoticComponent<
	({
		localId,
		closeConfigPanel,
		contentId,
		editorActions,
		editorApi,
		propsProvider,
	}: HubEditorConfigPanelProps) => React.JSX.Element | null
> = memo(
	({
		localId,
		closeConfigPanel,
		contentId,
		editorActions,
		editorApi,
		propsProvider,
	}: HubEditorConfigPanelProps): React.JSX.Element | null => {
		if (localId) {
			return (
				<HubErrorBoundary
					id="hub-editor-config-panel"
					packageName="@atlassian/hub-editor-config-panel"
					fallback={<GenericErrorPage />}
					shouldForceError={true}
				>
					<Suspense fallback={<UFOLoadHold name="editor-config-panel-chunk-loader" />}>
						<HubEditorConfigPanelLazy
							localId={localId}
							closeConfigPanel={closeConfigPanel}
							contentId={contentId}
							editorActions={editorActions}
							editorApi={editorApi}
							propsProvider={propsProvider}
						/>
					</Suspense>
				</HubErrorBoundary>
			);
		}

		return null;
	},
	isEqual,
);
